import type { Country } from '@/types/country';
import { Language } from './currencyConfig';

export function getCountryCode(lang: string): Country {
	switch (lang) {
		case 'cs':
			return 'CZ';
		case 'sk':
			return 'SK';
		case 'hu':
			return 'HU';
		default:
			return 'CZ';
	}
}

export const country: Country = getCountryCode(process.env.NEXT_PUBLIC_LANGUAGE);

export const COUNTRY_PUBLIC_LINK: Record<Language, string> = {
	cs: 'https://skippay.cz',
	sk: 'https://skippay.sk',
	hu: 'https://skippay.hu',
};
